import { httpClient } from '@/services/http/httpClient'

export async function deleteComment(id: string): Promise<void> {
  await httpClient.delete(`/ideas/idea-comments/${id}`)
}
